export type CountryIllustration = {
  /** Path to the illustration image in public/setup/ */
  image: string;
  /** Optional heading override (default: "Do business\nanywhere on\nEarth.") */
  heading?: string;
};

/**
 * Maps ISO 3166-1 alpha-2 country codes to illustration assets.
 * Add new entries here as country-specific illustrations become available.
 * The DEFAULT entry is used when the user's country has no specific illustration.
 */
export const COUNTRY_ILLUSTRATIONS: Record<string, CountryIllustration> = {
  US: { image: '/setup/login_illustration.svg' },
  CA: { image: '/setup/canada_auth.svg' },
  FR: { image: '/setup/france_auth.svg' },
  DE: { image: '/setup/germany_auth.svg' },
  IN: { image: '/setup/india_auth.svg' },
  GB: { image: '/setup/london_auth.svg' },
  SA: { image: '/setup/saudiarabia_auth.svg' },
  SG: { image: '/setup/singapore_auth.svg' },
  AE: { image: '/setup/uae_auth.svg' },
  DEFAULT: { image: '/setup/login_illustration.svg' },
};
